import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useGetKnowledgeBaseLimitOverage } from '../knowledge-base/hooks/knowledgeBaseHooks';
import { useAppSelector } from '../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const PermissionsTooltip = props => {
  const {
    isOverLimit
  } = useGetKnowledgeBaseLimitOverage();
  const canWriteArticle = useAppSelector(state => state.knowledgeScopes.canWriteArticle);
  const tooltipTitle = isOverLimit ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.downgrade"
  }) : !canWriteArticle ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.permissions"
  }) : null;
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    placement: "bottom left"
  }, props, {
    title: tooltipTitle
  }));
};
export default PermissionsTooltip;